import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

export default function DescriptionModal({
    visible,
    toggle,
    ...props
  }) {
    return (
      <Modal
        isOpen={visible}
        toggle={toggle}
        centered
        size={props.size ? props.size : 'lg'}
        backdrop='static'
      >
        <ModalHeader className='modal-title border-0 pb-1' toggle={toggle}>
          Job Description
        </ModalHeader>
        <ModalBody>
         <div dangerouslySetInnerHTML={{ __html: props?.jobDescription }}></div>
        </ModalBody>
      </Modal>
    );
  }
  